import $ from 'jquery'
import Emitter from './Emitter'
import { compile } from '../app'
import { SHOPIFY_UPDATE_ELEMENT } from '../events'

const init = () => {
	document.addEventListener('shopify:section:load', e => {
		Emitter.emit(SHOPIFY_UPDATE_ELEMENT)
		compile(e.target)
	})
}

export default init
